import * as getParticipants from './reducers/get';
import * as query from './reducers/query';
import * as create from './reducers/create';
import * as updateParticipant from './reducers/update-participant';
import { subscribe, unsubscribe } from './reducers/subscription';
import { update, bulk as bulkUpdate, addToSportCollection } from './reducers/update';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    PARTICIPANTS_REQUEST: getParticipants.request,
    PARTICIPANTS_ERROR: getParticipants.error,
    PARTICIPANTS_FINISH: getParticipants.finish,

    PARTICIPANTS_QUERY_REQUEST: query.request,
    PARTICIPANTS_QUERY_ERROR: query.error,
    PARTICIPANTS_QUERY_FINISH: query.finish,

    PARTICIPANT_UPDATED_FINISH: updateParticipant.finish,

    PARTICIPANTS_CREATE_REQUEST: create.request,
    PARTICIPANTS_CREATE_ERROR: create.error,
    PARTICIPANTS_CREATE_FINISH: create.finish,
    PARTICIPANTS_CREATE_CLEAR: create.clear,

    PARTICIPANTS_SUBSCRIBE: subscribe,
    PARTICIPANTS_UNSUBSCRIBE: unsubscribe,

    PARTICIPANTS_DATA: bulkUpdate,
    PARTICIPANT_DATA: update,
    PARTICIPANT_COLLECTION_ADD: addToSportCollection,
});
